import { VERIFICATION_VOLUMES, type VerificationVolume } from 'api/types';

import { StorageKeys, sessionStorageService } from './storageService';

const isVerificationVolume = (value: string): value is VerificationVolume =>
  (VERIFICATION_VOLUMES as readonly string[]).includes(value);

// Capture signup params before Auth0 redirects drop them; BaseApiClient forwards them once after login.
export const captureSignupParams = (search: string): void => {
  const params = new URLSearchParams(search);

  const plan = params.get('plan');
  if (plan) {
    sessionStorageService.set(StorageKeys.SELECTED_PLAN, plan);
  }

  const source = params.get('source');
  if (source === 'self_serve' || source === 'individual') {
    sessionStorageService.set(StorageKeys.SIGNUP_SOURCE, source);
  }

  const useCase = params.get('use_case');
  if (useCase) {
    sessionStorageService.set(StorageKeys.SIGNUP_USE_CASE, useCase);
  }

  const verificationVolume = params.get('verification_volume');
  if (verificationVolume && isVerificationVolume(verificationVolume)) {
    sessionStorageService.set(StorageKeys.SIGNUP_VERIFICATION_VOLUME, verificationVolume);
  }
};
